import Globals from '@/config/Globals';
//
export default class APITrainingHistory {
  constructor(API) {
    this.api = API;
  }

  async getAll(memberID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = Globals.APIPath_Member + memberID + '/personTrainings';
    return await req.exec();
  }
  
  async getByID(memberID, trainingID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = Globals.APIPath_Member + memberID + '/personTraining/' + trainingID;
    return await req.exec();
  }

  async create(memberID, trainingHistoryObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = Globals.APIPath_Member + memberID + '/personTraining/' + Globals.URL_NewIndentifier;
    req.body = { ...trainingHistoryObj };
    return await req.exec();
  }

  async update(memberID, trainingID, trainingHistoryObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = Globals.APIPath_Member + memberID + '/personTraining/' + trainingID;
    req.body = { ...trainingHistoryObj };
    return await req.exec();
  }

  async remove(memberID, trainingID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = Globals.APIPath_Member + memberID + '/personTraining/' + trainingID;
    return await req.exec();
  }
}
